import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { UrlKeys } from '../../shared/enums/urls.enum';
import { ApiPrivateService } from '../../shared/services/api-private.service';
import { InterceptorService } from '../services/interceptor.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const _apiPrivateService = inject(ApiPrivateService);
  const _interceptorService = inject(InterceptorService);
  const _router = inject(Router);

  const api = _apiPrivateService.apiURLs;
  const routerUrl = _router.url;
  const url = req.url;
  const pathSegments = routerUrl.split('?')[0].split('/').filter(Boolean);
  const requestPath = url.split('?')[0];
  const isCitasListRequest = req.method === 'GET' && requestPath === api.cita.citas;
  const isCitasListOnHome = isCitasListRequest && pathSegments.includes(UrlKeys.HOME);
  const isCitasListOnMisCitas = isCitasListRequest && pathSegments.includes(UrlKeys.CITAS);
  const isAdvancedSearchMap = url.includes(api.medicalDirectory.advancedSearchMap);
  const isKeepAlive = url.includes(api.home.keepAlive);
  const isLogoutRequest = requestPath === api.audit.logout;

  const skipLoading =
    isCitasListOnHome ||
    isCitasListOnMisCitas ||
    isAdvancedSearchMap ||
    isKeepAlive ||
    isLogoutRequest;
  _interceptorService.showLoading(skipLoading);

  return next(req).pipe(
    finalize(() => {
      _interceptorService.hideLoading(skipLoading);
    })
  );
};
